export default "__VITE_PUBLIC_ASSET__6b6ff44a__"